import { cardRef, defineGameCard, onResolve, planningTargets, tableTarget, targetStep, } from '../authoring/index.js';
import { addGrowth, hasTrait, isLiveOnBoard, plannedTableId, tableOf, } from './plant-helpers.js';
/** Полуденное солнце сразу даёт по 1 Росту всем Растениям в локации. */
export const MiddaySunCard = defineGameCard({
    id: 'midday_sun',
    gameplay: {
        type: 'SPELL',
        cost: 2,
        planning: planningTargets([
            targetStep('location', tableTarget({ cardinality: { min: 1, max: 1 } })),
        ]),
    },
    presentation: {
        name: 'Полуденное солнце',
        description: 'Все Растения в выбранной локации получают 1 Рост.',
        glyph: {
            colors: ['#10213A', '#F15607', '#FD830D', '#FFD520', '#FF9C08'],
            rows: [
                '.........11.2.......',
                '..122..22332.2...1..',
                '.132.2212332122.131.',
                '..1212112222112231..',
                '...13222444422231...',
                '..1222245555422222..',
                '..122244444554222...',
                '.2222445444454421122',
                '.112444544345445232.',
                '13324444543454442231',
                '13324444444454452331',
                '.122445443444545221.',
                '.2212445443444421222',
                '.2.12245444444221...',
                '...122255444422222..',
                '...13222455422231...',
                '..122221222212112222',
                '.132.2.133331.2.131.',
                '..122...1331.....1..',
                '....2....11.........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve({
            source: 'card_effect',
            dependencies: [cardRef('plant_growth')],
            run: (ctx) => {
                const tableId = plannedTableId(ctx, 'location');
                if (ctx.self === undefined || tableId === undefined)
                    return;
                const plants = ctx.q.allUnits().filter((unit) => isLiveOnBoard(unit)
                    && tableOf(unit.cellId) === tableId
                    && hasTrait(ctx, unit.id, 'PLANT'));
                for (const plant of plants) {
                    addGrowth(ctx, plant.id, 1, 'midday_sun');
                }
            },
        }),
    ],
    ui: {
        mechanics: ['growth'],
        planning: { steps: { location: { label: 'Выберите локацию' } } },
    },
});
//# sourceMappingURL=midday_sun.js.map